import {createSlice, type PayloadAction} from '@reduxjs/toolkit';
import {LOADING_STATES} from '@Libraries/email-marketing-campaigns-library';
import {emailMarketingCampaignPerformanceExtraReducers} from '@Components/email-marketing-campaign-performance/email-marketing-campaign-performance-extra-reducers';
import type {EmailMarketingCampaignPerformanceState} from './email-marketing-campaign-performance.types';
import {MetricItemType} from './email-marketing-campaign-performance.types';
import {getDefaultRecipientInsightsPaging, updateWindowLocationHash} from './email-marketing-campaign-performance-library';

const initialState: EmailMarketingCampaignPerformanceState = {
  performanceLoadingState: LOADING_STATES.NOT_LOADED,
  campaigns: {}, campaignsWithMetricsAvailable: {}, campaignsWithMetricsNotAvailable: {},
  campaignsWithMetricsCollecting: {}, mailingLists: {}, mailingListsWithAvailableMetrics: {},
  mailingListsWithMetricsNotAvailable: {}, mailingListsWithMetricsCollecting: {},
  campaignMetrics: {}, mailingListMetrics: {}, selectedItemIds: [], itemType: MetricItemType.CAMPAIGN,
  isNoCampaignCreated: false, isNoCampaignPublished: false, isCollectingData: false,
  isNoMailingListCreated: false, isNotCollectingData: false,
  detailsLoadingState: LOADING_STATES.NOT_LOADED,
  detailsTotalRows: null,
  detailsRequestedPaging: getDefaultRecipientInsightsPaging(),
  detailsLoadedRowsPaging: getDefaultRecipientInsightsPaging(),
  detailsLatestRequestId: '',
  latestInitRequestId: '',
  negativeOutcomeCounts: {},
};

const emailCampaignsPerformanceSlice = createSlice({
  name: 'emailCampaignsPerformance',
  initialState,
  reducers: {
    updateLoadingState: (state, action: PayloadAction<number>) => {
      state.performanceLoadingState = action.payload;
    },
  },
  extraReducers: emailMarketingCampaignPerformanceExtraReducers,
});

export const {updateLoadingState} = emailCampaignsPerformanceSlice.actions;
export const emailMarketingCampaignsPerformanceReducer = emailCampaignsPerformanceSlice.reducer;

export const syncPerformanceHashFromStore = (): void => {
  const {itemType, selectedItemIds} = window.PMW.redux.store.getState().emailMarketingCampaignsPerformance;
  updateWindowLocationHash(itemType, selectedItemIds, true);
};
